// extracted by mini-css-extract-plugin
export default {"countdown":"SZ-z","srOnly":"TZ-z"};